import React from "react";
import AreaManagementContainer from "../../modules/AreaManagement/containers/AreaManagementContainer/AreaManagementContainer";

const AreaManagement = () => {
  return (
    <AreaManagementContainer />
  );
};

export default AreaManagement;
